module.exports = __webpack_public_path__ + "static/social-share-1dead403c392d4ba778dd3674ed0b237.jpg";